import { render, staticRenderFns } from "./VisioMiddleware.vue?vue&type=template&id=a25bec02"
import script from "./VisioMiddleware.vue?vue&type=script&lang=js"
export * from "./VisioMiddleware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports